import { styled } from '@clickcease/cc-client-components-lib'

export const InvalidVisitsTrendsAndThreatGroupsStyled = {
  Wrapper: styled('div', {
    display: 'flex',
    paddingBottom: '$9',
    flexGrow: 1,
    '> div': {
      flexGrow: 1,
    },
  }),
  HeaderUtilities: styled('section', {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexGrow: 1,
    marginLeft: '$8',

    '&:before': {
      content: ' ',
      position: 'absolute',
      display: 'block',
      top: 0,
      left: '-$4',
      width: '2px',
      height: '100%',
      background: '$lightDisabled',
    },
  }),
  HeaderUtilitiesTitleWrapper: styled('div', {
    fontSize: '$md',
    fontWeight: '$l',
  }),
  Tab: styled('div', {
    display: 'flex',
    alignItems: 'center',
  }),
} as const
